var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1920px",
    height: "1715px",
    viewBox: "0 0 1920 1715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Postcard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-33",
    transform: "translate(-1255.000000, -366.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Postcard",
    transform: "translate(1254.000000, 363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(960.500000, 860.192444) scale(-1, 1) rotate(-180.000000) translate(-960.500000, -860.192444) translate(0.000000, 0.692444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    transform: "translate(45.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16-Clipped",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16",
    transform: "translate(0.615662, 0.946622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(0.691455, 0.651222)",
    fill: "#E2BA44",
    opacity: 0.513113839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9213847,157.484311 C4.9213847,157.484311 365.490326,161.052314 545.141784,127.909249 C724.794472,94.7649535 1184.85905,0.526588163 1184.85905,0.526588163 C1184.85905,0.526588163 1179.11948,130.25798 1188.49718,192.615615 C1197.87488,254.97202 182.686722,401.154371 116.363681,377.067884 C50.0406397,352.981396 0.275597543,283.026374 0.275597543,283.026374 C0.275597543,283.026374 33.3079317,252.244343 4.9213847,157.484311",
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(1149.309794, 596.058307)",
    fill: "#E2BA44",
    opacity: 0.513113839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3545785,0 C87.3545785,0 113.528963,7.66013529 253.379952,49.8917678 C393.229711,92.1246306 719.298515,154.716032 719.298515,154.716032 L685.37295,246.179966 L0.527818509,96.0949577 L87.3545785,0",
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(0.965453, 1047.231294)",
    fill: "#E2BA44",
    opacity: 0.513113839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C0,0 378.208414,53.7673582 539.428056,51.0729001 C700.646467,48.378442 1162.90475,16.1790522 1162.90475,16.1790522 L1033.00111,281.943669 L31.1585169,128.328797 L0,0 Z",
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(1392.259856, 253.424860)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path36",
    points: "15.9945003 0 0.874776131 25.0978316 392.925815 261.288617 408.04677 236.189555"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(1559.171202, 350.869753)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4551926,0 L0.257142351,30.206229 L224.906051,165.545539 C229.017868,168.020995 234.35757,166.695912 236.835487,162.585326 L246.063083,147.267516 C248.541001,143.155699 247.215918,137.815997 243.104101,135.33931 L18.4551926,0 Z",
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(1366.066893, 244.073491)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0676159,34.4496929 L1.05686737,4.24592465 C-0.4023232,2.55173797 1.14914333,-0.0233765773 3.32931675,0.474913624 L42.18734,9.35186128 L27.0676159,34.4496929 Z",
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(1708.929799, 447.862864)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23034618,2.46069235 L0.498290201,3.67381368 C-0.456458431,5.25849956 0.0541352317,7.31809905 1.64005145,8.27407803 L78.7507677,54.7282586 C80.3366839,55.6842376 82.3950531,55.1736439 83.3498017,53.5877277 L84.0818577,52.373376 C85.0366063,50.7886901 84.5247823,48.7290906 82.9400964,47.7755724 L5.82814984,1.3189311 C4.24346396,0.365412814 2.18386446,0.876006477 1.23034618,2.46069235",
    id: "path48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(1713.075082, 446.879940)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23034618,2.46069235 L0.499520547,3.67504403 C-0.455228085,5.2597299 0.0553655779,7.3193294 1.64005145,8.27407803 L78.751998,54.7294889 C80.3366839,55.6842376 82.3962834,55.1736439 83.351032,53.588958 L84.0818577,52.3746064 C85.0366063,50.7886901 84.5260126,48.730321 82.9413268,47.7755724 L5.82938018,1.32016145 C4.24469431,0.365412814 2.18509481,0.876006477 1.23034618,2.46069235",
    id: "path52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(1508.189962, 343.961114)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6690397,9.84276941 L52.2860214,35.3773739 L0.248529928,4.02692303 C0.248529928,4.02692303 24.459282,15.0815834 40.4931533,18.4576533 L40.491923,18.4576533 C40.491923,18.4576533 52.973785,20.2416553 53.9469888,11.4988154 C54.9201926,2.75351474 52.0940874,1.05194598 52.0940874,1.05194598 L67.4032849,10.150356 C67.5779941,9.95596126 67.6690397,9.84276941 67.6690397,9.84276941",
    id: "path56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(1717.276714, 451.267847)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3034618,9.84276941 L1.00273213,3.03526402 C-0.639780012,2.04483534 0.896922362,-0.509363317 2.5418952,0.482295701 L13.8426248,7.28980109 C15.485137,8.27899942 13.9496649,10.8344284 12.3034618,9.84276941",
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(1584.273217, 362.998998)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.804271,79.9725014 L2.17648239,7.90374383 C-1.9316435,5.42828733 1.90703657,-0.958439671 6.02254453,1.51947753 L125.650334,73.5894655 C129.757229,76.0636916 125.918549,82.451649 121.804271,79.9725014",
    id: "path64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(1427.267019, 272.500024)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.343579,77.5118091 L2.64893532,7.20859824 C-1.45919056,4.73560243 2.38071985,-1.65358526 6.49376712,0.825562284 L123.189641,71.1287731 C127.296537,73.6017689 123.457857,79.9897263 119.343579,77.5118091",
    id: "path68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(1413.957872, 264.818850)",
    fill: "#004C5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3034618,6.15173088 C12.4400302,6.62787485 12.4547943,7.10278847 12.3440632,7.57647175 C12.3157652,8.0759923 12.1607416,8.54106315 11.8789923,8.97168432 C11.3450221,9.77387002 10.5576005,10.4677853 9.58439671,10.6646407 C8.61488392,10.8627264 7.62937664,10.761838 6.76444328,10.2401712 L2.52713105,7.68720291 C1.70895084,7.19506444 1.0630191,6.32151865 0.832944361,5.39383764 C0.695145589,4.91646332 0.682842128,4.4415497 0.792342937,3.96909676 C0.820640899,3.46711552 0.976894864,3.00204467 1.25741379,2.57265385 C1.79138403,1.7692378 2.57880558,1.0765529 3.55323976,0.879697516 C4.52275254,0.682842128 5.50825983,0.783730514 6.37319319,1.30416695 L10.6092751,3.85713526 C11.4286856,4.34927373 12.073387,5.22404986 12.3034618,6.15173088",
    id: "path72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74",
    transform: "translate(1373.374534, 256.463446)",
    fill: "#F9B253"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path76",
    points: "17.2248465 0 1.12576675 26.7231189 418.537932 278.189883 434.637012 251.467994"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g78",
    transform: "translate(1551.240021, 360.212633)",
    fill: "#FBB03B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6855388,0 L0.311277583,32.1600187 L239.97287,176.542373 C244.084687,179.01906 249.42562,177.695207 251.902306,173.58339 L262.307344,156.311791 C264.784031,152.199974 263.458948,146.859041 259.347131,144.383584 L19.6855388,0 Z",
    id: "path80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(1344.971993, 246.275933)",
    fill: "#72420D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5283082,36.9103853 L1.83567649,4.75282728 C0.281749274,2.94790944 1.93287384,0.207928504 4.25576742,0.738207706 L45.6273879,10.1872663 L29.5283082,36.9103853 Z",
    id: "path84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(1709.683140, 463.452457)",
    fill: "#8C6239"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46069235,2.46069235 L1.45919056,4.12535073 C0.504441932,5.7100366 1.0150356,7.76840576 2.59972147,8.72438473 L85.071056,58.408224 C86.6557419,59.3629726 88.714111,58.8511486 89.67009,57.2664628 L90.6715918,55.6030347 C91.6275708,54.0171185 91.1169771,51.9587494 89.5310609,51.0040007 L7.05972636,1.32016145 C5.47504048,0.365412814 3.41544098,0.876006477 2.46069235,2.46069235",
    id: "path88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(1714.097500, 462.407155)",
    fill: "#C7B299"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46069235,2.46069235 L1.45919056,4.12412038 C0.503211586,5.7100366 1.0150356,7.76717541 2.59972147,8.72315439 L85.071056,58.4069937 C86.6557419,59.3617423 88.714111,58.8511486 89.67009,57.2664628 L90.6715918,55.6018044 C91.6275708,54.0171185 91.1157468,51.957519 89.5310609,51.0027704 L7.05972636,1.3189311 C5.47504048,0.364182468 3.41544098,0.876006477 2.46069235,2.46069235",
    id: "path92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94",
    transform: "translate(1496.453567, 353.493836)",
    fill: "#E88D15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5904244,9.84276941 L56.2120561,37.0284985 L0.809567784,3.6504371 C0.809567784,3.6504371 26.5865505,15.4199286 43.6576037,19.0150001 L43.6563734,19.0137698 C43.6563734,19.0137698 56.9441121,20.9134243 57.9812939,11.6046251 C59.0172454,2.29582596 56.0078186,0.483526047 56.0078186,0.483526047 L72.3086751,10.1700415 C72.4944574,9.96334333 72.5904244,9.84276941 72.5904244,9.84276941",
    id: "path96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(1719.175138, 466.510237)",
    fill: "#EFD7BF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5338079,11.0731156 L1.50348303,3.82514626 C-0.246069235,2.77196993 1.38906083,0.0516745394 3.14107379,1.10608121 L15.172629,8.35528088 C16.920951,9.40845721 15.2870512,12.1287526 13.5338079,11.0731156",
    id: "path100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g102",
    transform: "translate(1577.269594, 373.377583)",
    fill: "#F4C382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.416695,84.8938861 L3.05002817,8.16334688 C-1.32262214,5.52794537 2.76458786,-1.27217795 7.14462024,1.36568426 L134.511287,78.0974539 C138.883937,80.731625 134.797957,87.5329787 130.416695,84.8938861",
    id: "path104"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106",
    transform: "translate(1411.178889, 276.865169)",
    fill: "#F4C382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.725656,82.4331938 L2.48283858,7.58385383 C-1.88981173,4.94845232 2.19616792,-1.85167099 6.57743066,0.787421553 L130.820248,75.6379919 C135.194129,78.2709327 131.106919,85.0722863 126.725656,82.4331938",
    id: "path108"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g110",
    transform: "translate(1396.236827, 268.992799)",
    fill: "#F4C382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5338079,6.15173088 C13.6802191,6.6586335 13.6949833,7.16430578 13.5781004,7.66874771 C13.5473417,8.20148761 13.381245,8.69608677 13.0822709,9.15377555 C12.5126206,10.0100965 11.6747549,10.7470738 10.637573,10.957463 C9.60654294,11.1666219 8.55705765,11.0595818 7.63675871,10.5046957 L3.12507929,7.78686095 C2.25399419,7.26150313 1.56623068,6.33136142 1.32139179,5.34462379 C1.1749806,4.83772116 1.16021644,4.33204889 1.27709933,3.82760695 C1.30785799,3.29486706 1.47395472,2.79903755 1.77292884,2.34134877 C2.34257912,1.48625818 3.18044486,0.748050475 4.21639635,0.538891625 C5.24988713,0.329732775 6.29814207,0.435542546 7.21844101,0.991659018 L11.7301204,3.70949372 C12.6012055,4.23362119 13.288969,5.1637629 13.5338079,6.15173088",
    id: "path112"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(1101.534430, 551.537363)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path116",
    points: "664.386935 754.202206 0.153793272 1.03841217 0.198085734 1.05194598 664.395547 754.175138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g118",
    transform: "translate(639.641560, 662.616338)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path120",
    points: "424.469431 481.065355 0.4343122 0.258372697 0.441694277 0.231305081 424.513723 481.080119"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g122",
    transform: "translate(664.540444, 583.483671)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path124",
    points: "529.048856 600.408934 0.0196855388 0.551195087 0.14148981 0.156253964 529.696018 600.610711"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g126",
    transform: "translate(1361.000536, 632.197136)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path128",
    points: "453.997739 515.515048 0.214080235 0.976894864 0.709909744 1.13068814 454.091245 515.212383"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g130",
    transform: "translate(1741.879171, 750.805952)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path132",
    points: "145.180849 164.866388 0.412165969 0.714831128 1.05563702 0.915377555 145.302653 164.473907"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g134",
    transform: "translate(566.598122, 897.220223)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path136",
    points: "111.961502 126.725656 0.569650279 0.419548046 0.578262703 0.39248043 112.005794 126.73919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g138",
    transform: "translate(541.191104, 973.902902)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path140",
    points: "0 7.38207706 2.11373473 0.574571664 11.1789254 10.854114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "translate(1667.019127, 1316.461790)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path144",
    points: "40.6014238 27.0676159 0.622555165 14.6521926 16.9504793 0.25099062"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g146",
    transform: "translate(844.453351, 472.709945)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path148",
    points: "733.286321 830.483669 1.16267714 0.339575545 1.80983922 0.541352317 733.932253 830.685446"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g150",
    transform: "translate(715.019456, 432.513428)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path152",
    points: "733.286321 830.483669 733.240798 830.470135 1.11715433 0.327272083 6.15050053 1.88858138 4.11304727 3.68611714"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g154",
    transform: "translate(591.498237, 818.087556)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path156",
    points: "216.540927 246.069235 0.153793272 0.71114009 0.27682789 0.317429313 217.186859 246.269782"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g158",
    transform: "translate(1230.598236, 592.040236)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path160",
    points: "559.80751 634.858627 0.568419933 0.745589783 1.21558202 0.947366555 559.930545 634.464916"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g162",
    transform: "translate(542.481491, 936.177904)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path164",
    points: "71.3600782 67.6690397 9.88829222 48.5789884 0.823101592 38.2994461 12.4474123 0.869854746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g166",
    transform: "translate(566.151260, 857.045237)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path168",
    points: "177.169849 187.012619 112.45241 166.914914 1.02487836 40.5669741 13.2619014 1.16144679"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g170",
    transform: "translate(591.619672, 778.089248)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path172",
    points: "281.749274 306.356198 217.066285 286.268336 0.155023618 40.3159835 12.385895 0.930141709"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g174",
    transform: "translate(554.340429, 896.584626)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path176",
    points: "62.747655 108.270463 1.20327856 38.4864587 12.8275892 1.05563702 124.219441 127.361745"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g178",
    transform: "translate(554.929150, 934.586575)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path180",
    points: "0 2.46069235 0.613942742 0.484756393 62.1583192 70.2687611 58.9126659 69.2598773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g182",
    transform: "translate(578.455829, 817.674775)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path184",
    points: "164.866388 226.383696 0.958439671 40.5300637 13.1966931 1.1245364 229.583827 246.481401"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g186",
    transform: "translate(579.413531, 856.976215)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path188",
    points: "0 1.23034618 0.00123034618 1.22911583 163.909178 187.082748 163.907948 187.081518"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g190",
    transform: "translate(603.957953, 738.728997)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path192",
    points: "269.445813 345.727275 0.0553655779 40.268 12.2554783 0.984276941 333.962705 365.763463"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g194",
    transform: "translate(603.923134, 778.089248)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path196",
    points: "269.445813 306.356198 0.0824331938 0.930141709 0.0898152708 0.907995478 269.480262 306.367271"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g198",
    transform: "translate(615.736303, 702.221058)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path200",
    points: "322.350698 402.3232 0.508132971 37.3914506 12.1004546 0.0615173088 383.656387 421.362807"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g202",
    transform: "translate(615.569345, 739.079892)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path204",
    points: "322.350698 365.412814 0.64347105 0.633628281 0.675460051 0.532739894 322.518025 365.464489"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g206",
    transform: "translate(639.193468, 622.441475)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path208",
    points: "489.677778 541.352317 424.961569 521.254613 0.890770631 40.4057988 13.129024 1.00027144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g210",
    transform: "translate(664.661757, 543.485485)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path212",
    points: "594.257203 660.695896 529.575444 640.608034 0.020915885 40.1548081 12.2517872 0.76896636"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g214",
    transform: "translate(627.382514, 661.981356)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path216",
    points: "375.255584 462.610162 1.06794048 38.324053 12.6922512 0.89446167 436.7286 481.700213"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g218",
    transform: "translate(651.499267, 583.071012)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path220",
    points: "477.374316 580.723395 0.823101592 40.3701187 13.0601247 0.963361056 542.090525 600.8211"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g222",
    transform: "translate(652.322369, 622.211400)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path224",
    points: "0 1.23034618 0 1.22911583 476.551215 541.582392 476.548754 541.582392"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g226",
    transform: "translate(675.770921, 505.355458)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path228",
    points: "583.184087 698.836628 1.15037367 38.8777088 13.0859619 0.446615662 646.299616 718.438503"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g230",
    transform: "translate(675.734872, 543.485485)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path232",
    points: "583.184087 660.695896 1.17867164 0.76896636 1.18605371 0.748050475 583.219767 660.70697"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g234",
    transform: "translate(688.778510, 467.617296)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path236",
    points: "634.858627 756.662898 0.374025237 37.2302753 11.7018225 0.754202206 694.762952 775.266963"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g238",
    transform: "translate(688.442134, 504.041079)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path240",
    points: "633.628281 719.752513 0.414626661 1.76062538 0.709909744 0.807107091 635.194511 720.23973"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g242",
    transform: "translate(718.217864, 434.156432)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path244",
    points: "794.80363 848.938861 730.087421 828.841157 0.914147209 2.043605 2.95160048 0.246069235 62.6799859 18.7959985"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g246",
    transform: "translate(845.805009, 472.082714)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path248",
    points: "797.264322 851.399554 732.581333 831.311692 0.457688777 1.16882887 65.1406783 21.2566909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g250",
    transform: "translate(700.255302, 430.633582)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path252",
    points: "686.533166 813.258822 0.839096092 35.761242 11.6661424 0.896922362 15.8813084 2.20601069 748.004952 832.350104"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g254",
    transform: "translate(700.480087, 465.910560)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path256",
    points: "0 2.46069235 0.613942742 0.484756393 686.308013 777.982337 683.06236 776.973453"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g258",
    transform: "translate(779.736404, 452.612240)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path260",
    points: "733.286321 830.483669 1.16267714 0.339575545 65.8801163 20.4372803 798.00376 850.581374"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g262",
    transform: "translate(780.898342, 452.952308)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path264",
    points: "0 0 0.00123034618 0 732.124874 830.144093 732.123644 830.142863"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g266",
    transform: "translate(910.980998, 493.350601)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path268",
    points: "0 0 64.5168928 20.0349571 796.639306 850.17905 756.660438 837.763627 732.123644 830.142863"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g270",
    transform: "translate(1641.838985, 1323.482760)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path272",
    points: "1.23034618 0 1.26479587 0.0110731156 2.3659557 1.25864414 2.35242189 1.27217795"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g274",
    transform: "translate(909.783010, 492.998599)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path276",
    points: "733.286321 830.483669 1.16267714 0.340805891 1.19835718 0.351879006 733.320771 830.494742"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g278",
    transform: "translate(975.359108, 513.236810)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path280",
    points: "708.679397 803.416053 0.305125852 0.200546427 61.6108151 19.2401535 778.323143 831.90964 774.730532 843.481046 732.261443 830.292965 708.610498 803.47634"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g282",
    transform: "translate(975.290578, 513.296850)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path284",
    points: "708.679397 803.416053 0.207928504 0.0885849247 0.374025237 0.140259464 708.748297 803.355766"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g286",
    transform: "translate(1101.476727, 551.475477)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path288",
    points: "676.690397 714.831128 664.453374 754.236656 0.255912005 1.11469364 64.9721209 21.2123984"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g290",
    transform: "translate(1230.648680, 592.862107)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path292",
    points: "572.110972 594.257203 559.8801 633.643045 1.16513783 0.12549531 65.8481273 20.2133573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g294",
    transform: "translate(1360.841944, 632.459692)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path296",
    points: "466.301201 476.14397 454.24996 514.950319 0.8686244 0.8686244 64.599326 20.659973"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g298",
    transform: "translate(1489.963330, 673.025066)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path300",
    points: "349.418314 396.171469 0.195625042 0.194394696 62.8731503 19.6584712 361.270239 358.007361"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g302",
    transform: "translate(1617.402710, 712.336595)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path304",
    points: "246.069235 279.288582 0.150102233 0.445385316 60.1700797 19.0851299 257.419179 242.742379"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g306",
    transform: "translate(1742.364542, 750.499596)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path308",
    points: "156.253964 127.956002 144.816666 164.780263 0.570880626 1.22173375 61.0460862 20.0017378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g310",
    transform: "translate(1867.915095, 789.739150)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path312",
    points: "52.9048856 17.2248465 42.9403119 49.309814 0.214080235 0.861242323"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g314",
    transform: "translate(1039.465680, 532.372630)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path316",
    points: "714.831128 810.79813 0.749280821 1.11223294 62.2222972 20.2022842 726.455439 773.367308"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g318",
    transform: "translate(1165.455958, 572.390131)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path320",
    points: "612.712396 693.915243 0.995350056 0.298974121 65.7103286 20.3966789 624.949419 654.508486"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g322",
    transform: "translate(1166.448356, 572.687506)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path324",
    points: "0 0 0.00246069235 0.00123034618 611.719506 693.617499 611.718276 693.61873"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g326",
    transform: "translate(1295.864287, 612.525992)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path328",
    points: "506.902624 574.571664 0.668077974 0.55980751 65.3498371 20.6476695 519.133496 535.185822"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g330",
    transform: "translate(1296.496192, 613.075096)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path332",
    points: "0 0 0.0356800391 0.0110731156 506.270227 574.02293 506.262844 574.043846"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g334",
    transform: "translate(1426.237673, 652.774799)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path336",
    points: "401.092853 455.228085 0.190703657 0.652083473 63.2213383 20.2268911 413.012447 416.848666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g338",
    transform: "translate(1424.819945, 652.145230)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path340",
    points: "402.3232 456.458431 0.621324819 0.974434171 1.6092928 1.28202072 402.510212 455.858022"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g342",
    transform: "translate(1488.600845, 672.221773)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path344",
    points: "350.64866 397.401815 0.857551285 0.780039476 1.5588486 0.997810749 350.780307 396.974885"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g346",
    transform: "translate(1553.743123, 691.871263)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path348",
    points: "297.743775 338.345198 0.433081854 1.22788548 59.5512156 19.5883415 308.92393 302.34773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g350",
    transform: "translate(1552.259202, 691.457375)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path352",
    points: "298.974121 339.575545 0.577032357 1.22665514 1.91687934 1.6412818 299.227572 338.758595"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g354",
    transform: "translate(1676.819818, 730.888493)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path356",
    points: "198.085734 223.923004 1.19343579 0.66930832 65.4716414 20.631675 210.240324 184.783231"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g358",
    transform: "translate(1677.573159, 731.421356)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path360",
    points: "0 0 0.439233585 0.136568426 197.332762 223.390264 197.247869 223.65848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g362",
    transform: "translate(1807.143991, 771.292938)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path364",
    points: "92.2759632 104.579425 0.509363317 0.525357817 59.8784877 18.964556 103.502872 68.4293936"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g366",
    transform: "translate(540.843778, 973.247496)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "path368",
    points: "2.46069235 1.23034618 11.525883 11.5086581 0.346957622 8.03785157 2.48775997 1.14176125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(592.272002, 479.967019)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path372",
    points: "1274.63864 350.64866 146.156513 0.188242965 0.605330319 468.865242 1129.08746 819.324429"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g374",
    transform: "translate(-0.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g376-Clipped",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g376",
    transform: "translate(0.092853, 0.683278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g382",
    transform: "translate(1422.053673, 833.110212)",
    fill: "#D3B39C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.529928,121.804271 C247.297121,53.5102159 190.933732,-0.853860246 122.640907,0.377716276 C54.3468513,1.61052314 -0.0184551926,57.9726815 1.21435168,126.266737 C2.44715854,194.560793 58.8093169,248.924869 127.104603,247.693292 C195.397428,246.460485 249.761504,190.098327 248.529928,121.804271",
    id: "path384"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g386",
    transform: "translate(1414.874726, 825.591074)",
    stroke: "#E5CDBD",
    strokeWidth: 5.3333332
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.294082,129.186348 C261.987454,56.7017339 202.165562,-0.996580403 129.682178,0.311277583 C57.1987937,1.61913557 -0.499520547,61.439797 0.807107091,133.923181 C2.11619542,206.406566 61.9356265,264.10611 134.420241,262.798252 C206.903625,261.490394 264.60194,201.669733 263.294082,129.186348 Z",
    id: "path388"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g390",
    transform: "translate(1466.689771, 760.740881)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 259.295457,
    y2: 75.1101734,
    id: "path392"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g394",
    transform: "translate(1483.130025, 722.824810)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 259.295457,
    y2: 75.1101734,
    id: "path396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g398",
    transform: "translate(1494.077031, 686.686959)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 259.295457,
    y2: 75.1101734,
    id: "path400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g402",
    transform: "translate(1172.927765, 579.410739)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 419.548046,
    x2: 144.932319,
    y2: 0.963361056,
    id: "path404"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g406",
    transform: "translate(704.802700, 680.145947)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 466.804412,
    y2: 144.085841,
    id: "path408"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g410",
    transform: "translate(722.835022, 647.381951)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 466.804412,
    y2: 144.08461,
    id: "path412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g414",
    transform: "translate(736.171729, 606.428526)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 466.803182,
    y2: 144.085841,
    id: "path416"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g418",
    transform: "translate(425.660775, 1018.226252)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path420",
    points: "792.342937 551.195087 0.374025237 0.869854746 0.4183177 0.872315439 792.345398 551.168019"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g422",
    transform: "translate(20.679782, 1227.114672)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path424",
    points: "505.672278 351.879006 0.0922759632 0.562268202 0.0935063094 0.53397024 505.716571 351.881467"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g426",
    transform: "translate(25.150613, 1147.612040)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path428",
    points: "631.167588 439.233585 0.4023232 0.926450671 0.426930123 0.531509548 631.817211 439.272956"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g430",
    transform: "translate(686.234561, 1034.312659)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path432",
    points: "541.352317 376.48593 0.303895505 0.520436432 0.800955361 0.551195087 541.370773 376.182034"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g434",
    transform: "translate(1068.178922, 1057.311274)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path436",
    points: "173.478811 120.573925 0.869854746 0.631167588 1.51578649 0.66930832 173.503418 120.180214"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g438",
    transform: "translate(6.473097, 1462.107839)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path440",
    points: "132.877387 93.5063094 0.062747655 1.21681237 0.0652083473 1.18851441 132.921679 93.5087701"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g442",
    transform: "translate(1.463989, 1539.902012)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path444",
    points: "0 7.38207706 0.412165969 0.549964741 11.2207571 8.0599978"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g446",
    transform: "translate(1131.683609, 1598.330783)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path448",
    points: "40.6014238 19.6855388 0.471222585 17.2605265 12.4018895 0.091045617"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g450",
    transform: "translate(168.368199, 1002.349496)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path452",
    points: "873.545785 607.791011 0.631167588 1.21804271 1.27956002 1.25741379 874.195408 607.830382"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g454",
    transform: "translate(38.446472, 994.500625)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path456",
    points: "873.545785 607.791011 873.501492 607.78855 0.586875126 1.21558202 5.63744618 1.52070787 4.14872731 3.66397091"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g458",
    transform: "translate(10.943929, 1382.605083)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path460",
    points: "258.372697 180.860888 0.374025237 1.58222518 0.396171469 1.18605371 259.021089 180.900259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g462",
    transform: "translate(555.936841, 1026.443365)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path464",
    points: "666.847627 463.840508 0.0639780012 0.504441932 0.713600782 0.54381301 666.872234 463.444337"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g466",
    transform: "translate(1.798028, 1502.476112)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path468",
    points: "72.5904244 49.213847 10.8873333 45.4858981 0.0775118091 37.9758651 2.34873085 0.403553546"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g470",
    transform: "translate(6.268860, 1422.972864)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path472",
    points: "198.085734 136.568426 133.125917 132.644852 0.269445813 40.3233656 2.65877809 0.76896636"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g474",
    transform: "translate(11.311557, 1343.504436)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path476",
    points: "323.581044 223.923004 258.654446 220.00066 0.028297962 40.2876855 2.41763024 0.75297186"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g478",
    transform: "translate(3.826254, 1463.301520)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path480",
    points: "73.8207706 88.5849247 0.439233585 37.5944578 2.70922228 0.0233765773 135.523862 92.3128736"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g482",
    transform: "translate(4.147005, 1500.419219)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path484",
    points: "0 2.46069235 0.119343579 0.477374316 73.4996502 51.4678412 70.2416935 51.2709858"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g486",
    transform: "translate(8.732013, 1383.601787)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path488",
    points: "195.625042 175.939503 0.195625042 40.140044 2.58618766 0.58564478 260.584859 179.864307"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g490",
    transform: "translate(8.927761, 1422.512100)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path492",
    points: "0 1.23034618 0 1.22911583 195.429417 137.029805 195.426956 137.029805"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g494",
    transform: "translate(12.576845, 1304.135696)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path496",
    points: "322.350698 263.294082 1.15406471 40.1006729 3.53601491 0.668077974 387.109969 267.206582"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g498",
    transform: "translate(12.541903, 1343.504436)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path500",
    points: "322.350698 223.923004 1.18728406 0.75297186 1.18851441 0.732055975 322.385148 223.925465"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g502",
    transform: "translate(15.985519, 1266.226269)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path504",
    points: "383.868007 305.125852 0.132877387 38.4753856 2.39671435 1.00519283 445.405001 308.842727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g506",
    transform: "translate(15.818438, 1304.356789)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path508",
    points: "383.868007 266.98512 0.294052736 0.446615662 0.300204467 0.344496929 384.035334 266.994963"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g510",
    transform: "translate(20.475544, 1187.979698)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path512",
    points: "570.880626 394.941122 505.920808 391.017549 0.297743775 39.6688214 2.68830639 0.114422194"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g514",
    transform: "translate(25.518241, 1108.511269)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path516",
    points: "696.375936 482.295701 631.449338 478.373357 0.0590566164 39.631911 2.44715854 0.0984276941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g518",
    transform: "translate(18.032815, 1227.078623)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path520",
    points: "446.615662 348.187968 0.469992239 38.1690294 2.73998093 0.597948242 508.318753 351.914686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g522",
    transform: "translate(22.938574, 1147.378889)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path524",
    points: "568.419933 435.542546 0.22515335 40.7146157 2.61448562 1.16021644 633.379751 439.46612"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g526",
    transform: "translate(23.163358, 1186.864143)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path528",
    points: "0 1.23034618 0 1.22911583 568.19478 396.057046 568.192319 396.057046"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g530",
    transform: "translate(26.783406, 1069.142652)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path532",
    points: "695.145589 521.666779 1.18359302 39.4448984 3.51263833 0.8686244 758.498575 525.494386"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g534",
    transform: "translate(26.748587, 1108.511269)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path536",
    points: "695.145589 482.295701 1.21681237 0.0984276941 1.21804271 0.0762814629 695.180039 482.298162"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g538",
    transform: "translate(30.192203, 1031.233103)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path540",
    points: "756.662898 563.498549 0.163636041 37.8208414 2.37579847 1.20573925 816.793607 567.131761"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g542",
    transform: "translate(29.849675, 1068.048628)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path544",
    points: "755.432552 526.588163 0.446615662 1.96240215 0.505672278 1.00519283 757.004934 526.6829"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g546",
    transform: "translate(41.890088, 995.963999)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path548",
    points: "935.063094 610.251703 870.102046 606.328129 0.704988359 2.19985896 2.19370723 0.0578262703 62.147246 3.67996541"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g550",
    transform: "translate(168.735826, 1002.619803)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path552",
    points: "938.754132 611.482049 873.827534 607.559706 0.911686516 0.987967979 65.8395149 4.91031159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g554",
    transform: "translate(32.064052, 994.460885)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path556",
    points: "818.180207 604.099972 0.622555165 35.9950077 2.73752024 1.00027144 6.96868074 1.25618345 879.883298 607.827921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g558",
    transform: "translate(32.567509, 1029.978765)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path560",
    points: "0 2.46069235 0.119343579 0.477374316 817.676995 568.582339 814.417808 568.385484"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g562",
    transform: "translate(103.408505, 998.424691)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path564",
    points: "873.545785 607.791011 0.631167588 1.21927306 65.590985 5.14284702 938.505602 611.715815"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g566",
    transform: "translate(104.036965, 999.643595)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path568",
    points: "0 0 0.00246069235 0 872.917078 606.571738 872.915848 606.571738"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g570",
    transform: "translate(234.609791, 1007.531591)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path572",
    points: "0 0 64.759271 3.91250084 937.675119 610.484239 897.544917 608.060457 872.914617 606.572968"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g574",
    transform: "translate(1106.294431, 1612.873844)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path576",
    points: "1.23034618 1.23034618 2.54312555 2.14326304 2.53328278 2.15802719 1.19589648 1.22788548"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g578",
    transform: "translate(233.944174, 1006.310841)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path580",
    points: "873.545785 607.791011 0.631167588 1.21927306 0.665617281 1.22050341 873.580235 607.793472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g582",
    transform: "translate(298.888243, 1010.244627)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path584",
    points: "845.247823 588.105472 0.647162089 1.20943029 62.1841564 4.92630609 916.727245 598.731972 916.024717 610.34767 873.396913 607.771325 845.197379 588.176832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g586",
    transform: "translate(298.837798, 1010.316110)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path588",
    points: "845.247823 588.105472 0.531509548 1.12822744 0.697606282 1.13807021 845.298267 588.034112"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g590",
    transform: "translate(425.592245, 1018.015371)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path592",
    points: "794.80363 511.824009 792.414297 551.378408 0.487217086 1.08393498 65.4470345 5.00750894"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g594",
    transform: "translate(555.888734, 1025.884665)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path596",
    points: "669.30832 424.469431 666.920218 464.002914 0.761584283 1.10239017 65.6881823 5.02473378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g598",
    transform: "translate(686.145730, 1034.427942)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path600",
    points: "543.81301 337.114852 541.459358 376.067612 0.890770631 0.435542546 64.8613897 4.30005988"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g602",
    transform: "translate(815.261088, 1041.625591)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path604",
    points: "417.087354 290.361698 0.706218705 1.02733906 63.6187401 4.82787839 419.548046 249.632318"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g606",
    transform: "translate(942.999688, 1049.887242)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path608",
    points: "294.052736 204.237465 0.842787131 0.490908124 61.0866876 4.13027211 296.26859 167.553464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g610",
    transform: "translate(1069.205031, 1056.864904)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path612",
    points: "174.709157 83.66354 172.477309 120.6256 0.489677778 1.11592398 61.1924974 4.78358593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g614",
    transform: "translate(1195.344427, 1065.077342)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path616",
    points: "52.9048856 3.69103853 50.9597083 35.8953497 0.0159945003 0.495829509"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g618",
    transform: "translate(363.104070, 1015.196032)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path620",
    points: "852.6299 591.796511 1.22665514 0.172248465 62.9297462 3.90019738 854.899889 554.225429"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g622",
    transform: "translate(490.800592, 1022.935525)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path624",
    points: "729.595282 506.902624 0.239917504 0.0873545785 65.1997349 4.01215888 731.983384 467.348225"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g626",
    transform: "translate(491.039648, 1023.023249)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path628",
    points: "0 0 0.00123034618 0 729.356595 506.81527 729.356595 506.8165"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g630",
    transform: "translate(621.098312, 1030.784395)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path632",
    points: "604.099972 419.548046 0.513054355 0.126725656 65.4396524 4.04906927 606.488074 380.014563"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g634",
    transform: "translate(621.576548, 1030.909398)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path636",
    points: "0 0 0.0344496929 0.00123034618 603.621368 419.422551 603.620137 419.444697"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g638",
    transform: "translate(751.390127, 1038.746212)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path640",
    points: "478.604662 332.193468 0.606560665 0.04183177 63.8734217 3.86451734 480.932477 293.670098"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g642",
    transform: "translate(750.123731, 1038.118981)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path644",
    points: "479.835009 333.423814 0.883388554 0.609021357 1.87258688 0.66930832 479.870689 332.820944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g646",
    transform: "translate(815.234758, 1042.054489)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path648",
    points: "417.087354 290.361698 0.028297962 0.556116472 0.733286321 0.597948242 417.113191 289.932307"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g650",
    transform: "translate(879.141768, 1045.561099)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path652",
    points: "355.570045 247.299581 1.08393498 0.974434171 60.4247614 4.55843258 357.910163 208.563362"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g654",
    transform: "translate(877.862208, 1046.380633)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path656",
    points: "356.800391 247.299581 1.01749629 0.0725904244 2.363495 0.153793272 356.849605 246.480171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g658",
    transform: "translate(1004.288644, 1053.535588)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path660",
    points: "234.99612 163.636041 0.238687158 0.509363317 64.7605013 4.4071 237.369457 124.349858"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g662",
    transform: "translate(1004.086868, 1054.017391)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path664",
    points: "0 0 0.440463931 0.0270676159 235.197896 163.153746 235.180672 163.423192"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g666",
    transform: "translate(1131.952686, 1063.016635)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path668",
    points: "111.961502 77.5118091 1.12207571 0.32481139 63.4071205 2.55665935 114.386514 37.3889899"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g670",
    transform: "translate(0.645809, 1539.221385)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "path672",
    points: "1.23034618 1.23034618 12.0389373 8.74037923 0.818180207 8.06245849 1.23649791 1.14176125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g674",
    transform: "translate(41.940533, 1034.272427)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path676",
    points: "1161.44679 68.8993859 28.7175101 0.468761893 0.296513428 470.908847 1133.02579 539.339471"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g678",
    transform: "translate(892.031613, 1288.558775)",
    fill: "#E5CDBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path680",
    points: "228.844389 13.5338079 14.6977154 0.596717895 1.21681237 223.745834 215.363486 236.682924"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g682",
    transform: "translate(793.587063, 1343.150588)",
    fill: "#CEB9AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.636041,59.0566164 C156.805159,56.7078856 149.815563,59.1882635 142.950231,60.3214123 C136.007388,61.468095 129.146977,61.7326194 122.322247,59.7985152 C109.582013,56.1874492 100.853937,45.3776277 88.7301055,40.7785937 C74.533141,35.3921381 58.124014,43.559176 43.2663536,40.8671786 C27.9165547,38.0865962 15.5651095,28.482514 3.94325949,18.6643515 C-5.31509548,10.8430408 5.15268978,-5.10101525 14.532849,2.82241413 C25.4201823,12.0204821 37.3336244,22.5313295 52.3647636,22.6605159 C67.6308989,22.7921629 82.0850058,17.1190367 96.9291324,23.5746631 C107.869371,28.3311814 116.869353,38.9035461 128.486282,41.7653313 C134.873009,43.3401744 141.515648,41.0824892 147.805177,40.015779 C155.333665,38.7386797 162.511505,38.5172174 169.800076,41.0234325 C181.378864,45.0036024 175.268964,63.0552415 163.636041,59.0566164",
    id: "path684"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g686",
    transform: "translate(799.433668, 1310.446018)",
    fill: "#CEB9AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.636041,59.0566164 C156.805159,56.7091159 149.815563,59.1882635 142.950231,60.3226427 C136.006157,61.4693253 129.145747,61.7338497 122.322247,59.7997455 C109.582013,56.1886795 100.852706,45.3776277 88.7301055,40.7785937 C74.533141,35.3933684 58.124014,43.5604064 43.2663536,40.8684089 C27.9165547,38.0878266 15.5651095,28.4837443 3.94325949,18.6643515 C-5.31509548,10.8430408 5.15268978,-5.10101525 14.532849,2.82364447 C25.4201823,12.0204821 37.3336244,22.5325599 52.3635332,22.6617462 C67.6308989,22.7921629 82.0850058,17.120267 96.9279021,23.5746631 C107.86814,28.3311814 116.868123,38.9047764 128.486282,41.7665616 C134.873009,43.3401744 141.515648,41.0837195 147.805177,40.015779 C155.333665,38.7386797 162.511505,38.5184477 169.800076,41.0234325 C181.378864,45.0048328 175.267734,63.0552415 163.636041,59.0566164",
    id: "path688"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g690",
    transform: "translate(798.703089, 1275.316928)",
    fill: "#CEB9AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.636041,59.0566164 C156.805159,56.7091159 149.815563,59.1882635 142.949001,60.3226427 C136.006157,61.4693253 129.145747,61.7338497 122.322247,59.7997455 C109.582013,56.1886795 100.852706,45.3776277 88.7301055,40.7785937 C74.533141,35.3933684 58.124014,43.5604064 43.2663536,40.8684089 C27.9153244,38.0878266 15.5651095,28.4837443 3.94325949,18.6643515 C-5.31509548,10.8430408 5.15268978,-5.10101525 14.532849,2.82364447 C25.4201823,12.0204821 37.3336244,22.5325599 52.3635332,22.6617462 C67.6308989,22.7921629 82.0850058,17.120267 96.9279021,23.5746631 C107.86814,28.3311814 116.868123,38.9047764 128.485051,41.7665616 C134.873009,43.3401744 141.515648,41.0837195 147.805177,40.015779 C155.333665,38.7386797 162.510275,38.5184477 169.800076,41.0234325 C181.378864,45.0048328 175.267734,63.0552415 163.636041,59.0566164",
    id: "path692"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g694",
    transform: "translate(807.553461, 1224.163194)",
    stroke: "#CEB9AB",
    strokeWidth: 5.3333332
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 345.625157,
    y2: 14.7321651,
    id: "path696"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g698",
    transform: "translate(420.228674, 92.107775)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path700",
    points: "892.000978 394.941122 0.0565959241 0.99411971 0.102118733 0.987967979 891.997287 394.915285"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g702",
    transform: "translate(50.890563, 362.151905)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path704",
    points: "569.650279 252.220966 0.248529928 0.732055975 0.244838889 0.704988359 569.695802 252.216045"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g706",
    transform: "translate(41.092209, 284.759070)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path708",
    points: "711.14009 314.968621 0.749280821 1.20819994 0.702527666 0.824331938 711.798325 314.8948"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g710",
    transform: "translate(683.343740, 63.433696)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path712",
    points: "610.251703 269.445813 0.901843747 0.312507929 1.40751603 0.255912005 610.216023 269.150529"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g714",
    transform: "translate(1070.607256, 20.380069)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path716",
    points: "195.625042 86.1242323 1.22665514 0.263294082 1.8811993 0.189473311 195.579519 85.7403643"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g718",
    transform: "translate(78.299354, 591.542936)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path720",
    points: "150.102233 66.4386935 0.522897125 0.374025237 0.519206086 0.346957622 150.147756 66.4337721"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g722",
    transform: "translate(87.454852, 666.137595)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path724",
    points: "1.23034618 7.38207706 0.428160469 0.741898744 12.5999752 6.11851153"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g726",
    transform: "translate(1233.214728, 526.822421)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path728",
    points: "41.83177 14.7641541 1.16882887 19.2856763 10.0740745 0.738207706"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g730",
    transform: "translate(158.668396, 121.965324)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path732",
    points: "984.276941 434.3122 1.16882887 0.0996580403 1.82706407 0.0258372697 984.935176 434.238379"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g734",
    transform: "translate(27.023816, 135.374128)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path736",
    points: "984.276941 435.542546 984.231418 435.548698 1.12207571 1.33615595 6.2403158 0.766505668 5.13054355 3.08078682"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g738",
    transform: "translate(68.501123, 514.150102)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path740",
    points: "291.592044 129.186348 1.02487836 0.850169208 0.97812521 0.466301201 292.250279 129.112528"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g742",
    transform: "translate(551.190904, 77.939600)",
    fill: "#EFC7A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path744",
    points: "751.741514 332.193468 0.786191206 0.516745394 1.44442641 0.442924623 751.695991 331.8096"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g746",
    transform: "translate(82.605565, 629.622397)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path748",
    points: "79.9725014 35.6800391 17.4499998 42.6327253 5.27695475 37.2561126 0.863703016 0.739438052"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g750",
    transform: "translate(74.037681, 552.229562)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path752",
    points: "220.231965 98.4276941 154.409675 105.747023 4.78112524 39.660209 0.134107733 1.21558202"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g754",
    transform: "translate(64.817220, 476.002234)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path756",
    points: "361.721776 159.945003 295.933935 167.260641 4.66178166 38.6144147 0.0172248465 0.189473311"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g758",
    transform: "translate(78.525245, 591.114038)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path760",
    points: "87.3545785 73.8207706 4.71099551 37.3200906 0.296513428 0.802185707 149.87585 66.8680843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g762",
    transform: "translate(82.239168, 627.900650)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path764",
    points: "1.23034618 2.46069235 0.997810749 0.53397024 83.6401634 37.0346502 80.3391446 37.4012934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g766",
    transform: "translate(69.117403, 514.087600)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path768",
    points: "225.15335 136.568426 5.05426209 39.3563135 0.40847493 0.912916863 290.97564 129.249096"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g770",
    transform: "translate(74.172157, 552.215167)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path772",
    points: "0 1.23034618 0 1.22911583 220.099088 98.4412279 220.097858 98.4424582"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g774",
    transform: "translate(59.931885, 436.627466)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path776",
    points: "366.64316 199.316081 4.89923847 39.5445564 0.268215466 1.21804271 432.262443 192.017667"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g778",
    transform: "translate(64.817220, 476.002234)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path780",
    points: "361.721776 159.945003 0.0172248465 0.189473311 0.0147641541 0.169787772 361.757456 159.941312"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g782",
    transform: "translate(55.590854, 401.013496)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path784",
    points: "436.772892 227.614043 4.59657331 36.7332154 0.194394696 0.314968621 499.126837 220.678581"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g786",
    transform: "translate(59.112474, 436.711621)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path788",
    points: "433.081854 191.934003 1.08762602 1.13437917 1.07532256 1.03595148 433.251642 191.915548"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g790",
    transform: "translate(45.397190, 324.067646)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path792",
    points: "641.010358 282.97962 575.189298 290.30018 5.73833456 38.7891239 1.0925474 0.344496929"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g794",
    transform: "translate(36.178083, 246.611080)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path796",
    points: "782.500168 345.727275 716.712328 353.042914 5.61653029 38.9724455 0.973203825 0.547504048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g798",
    transform: "translate(51.115224, 361.723006)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path800",
    points: "506.902624 259.603043 4.43662831 37.6768909 0.0246069235 1.16021644 569.425126 252.650357"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g802",
    transform: "translate(41.708612, 285.926915)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path804",
    points: "644.701396 321.120352 4.77989489 38.483998 0.132877387 0.0406014238 710.523686 313.801023"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g806",
    transform: "translate(45.259022, 323.182166)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path808",
    points: "1.23034618 1.23034618 1.22911583 1.22911583 641.150617 283.86547 641.148156 283.86547"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g810",
    transform: "translate(32.523094, 208.466780)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path812",
    points: "786.191206 383.868007 4.62610162 38.672241 0.0935063094 1.17744129 850.385749 376.728308"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g814",
    transform: "translate(36.178083, 246.611080)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path816",
    points: "782.500168 345.727275 0.973203825 0.547504048 0.970743133 0.527818509 782.535848 345.723584"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g818",
    transform: "translate(28.180833, 172.852811)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path820",
    points: "856.320938 412.165969 4.32343646 35.8596696 0.0221462312 0.275597543 917.248911 405.389222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g822",
    transform: "translate(31.509043, 208.709527)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path824",
    points: "851.399554 376.48593 1.10731156 0.935063094 0.995350056 0.00369103853 852.992852 376.30876"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g826",
    transform: "translate(31.327566, 129.284899)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path828",
    points: "1045.79425 434.3122 979.97319 441.63153 0.82679263 9.16977005 1.93656488 6.85548889 62.6861377 0.0996580403"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g830",
    transform: "translate(159.907108, 114.575988)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path832",
    points: "1049.48529 434.3122 983.696217 441.627838 0.589335818 7.4152964 66.3771762 0.0996580403"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g834",
    transform: "translate(23.511792, 136.181482)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path836",
    points: "925.220324 441.694277 4.4575442 35.0181129 0.346957622 1.00519283 4.63471404 0.529048856 987.742826 434.741591"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g838",
    transform: "translate(26.972141, 170.667224)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path840",
    points: "1.23034618 2.46069235 0.997810749 0.532739894 921.759361 407.208904 918.458342 407.575547"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g842",
    transform: "translate(92.847336, 121.902822)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path844",
    points: "984.276941 441.694277 1.16882887 7.4817351 66.9898886 0.162405695 1050.098 434.374948"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g846",
    transform: "translate(94.013950, 129.384557)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path848",
    points: "0 0 0.00246069235 0 983.110573 434.212542 983.108112 434.212542"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g850",
    transform: "translate(226.319472, 107.288770)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path852",
    points: "0 7.38207706 65.6192829 0.0848938861 1048.72739 434.297436 1008.06445 438.818958 983.108112 441.594619"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g854",
    transform: "translate(1208.196992, 547.653043)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path856",
    points: "1.23034618 1.23034618 2.70922228 1.88366 2.7018402 1.90088484 1.19589648 1.23526756"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g858",
    transform: "translate(225.115456, 114.575988)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path860",
    points: "984.276941 434.3122 1.16882887 0.0996580403 1.20450891 0.0947366555 984.31139 434.307279"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g862",
    transform: "translate(291.037527, 99.321664)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path864",
    points: "952.28794 428.160469 1.07040117 8.03293018 63.4243454 1.09992948 1025.6055 424.243047 1027.20372 437.461886 984.008725 442.265158 952.25103 428.237981"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g866",
    transform: "translate(291.000247, 106.781745)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path868",
    points: "952.28794 420.778392 0.938754132 0.591796511 1.10731156 0.573341318 952.324851 420.70088"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g870",
    transform: "translate(419.269865, 85.625573)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path872",
    points: "888.309939 362.952122 892.955726 401.396749 1.0605584 7.46943163 66.8828485 0.150102233"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g874",
    transform: "translate(551.421594, 69.889445)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path876",
    points: "746.820129 301.434813 751.464686 339.858524 1.21312133 8.49307965 67.0009617 1.17621094"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g878",
    transform: "translate(683.652557, 56.038454)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path880",
    points: "605.330319 238.687158 609.907206 276.54614 1.09869914 7.65152287 65.9182571 0.442924623"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g882",
    transform: "translate(814.344357, 40.970282)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path884",
    points: "469.992239 215.310581 1.05071563 8.19041449 64.7974117 1.10239017 465.491633 178.077845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g886",
    transform: "translate(944.226466, 26.809243)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path888",
    points: "330.963121 153.793272 0.739438052 7.94311491 61.7842939 1.15406471 326.653219 118.13907"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g890",
    transform: "translate(1072.371080, 13.599878)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path892",
    points: "189.473311 56.5959241 193.815203 92.5208021 0.118113233 6.96991109 61.6268096 0.129186348"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g894",
    transform: "translate(1199.278090, 0.450553)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path896",
    points: "54.1352317 0 57.9185462 31.3000067 0.542582664 5.95979688"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g898",
    transform: "translate(356.972763, 92.944041)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path900",
    points: "959.670017 430.621162 0.789882245 7.1089402 63.3123839 0.157484311 955.256766 394.104487"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g902",
    transform: "translate(485.708558, 78.242266)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path904",
    points: "821.871246 370.334199 0.445385316 7.53340964 66.2676754 0.214080235 817.224228 331.890802"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g906",
    transform: "translate(486.153205, 85.775798)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path908",
    points: "0 0 0.00123034618 0 821.427091 362.800789 821.427091 362.80202"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g910",
    transform: "translate(617.857826, 63.717291)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path912",
    points: "680.381435 307.586544 0.600408934 7.34516667 66.3882493 0.028297962 675.738109 269.162833"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g914",
    transform: "translate(618.422555, 69.835310)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path916",
    points: "0 1.23034618 0.0356800391 1.22665514 679.816706 301.468032 679.819167 301.488948"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g918",
    transform: "translate(750.020382, 48.069994)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path920",
    points: "538.891625 246.069235 0.553655779 8.2999153 64.6608433 1.17005921 534.366412 208.62611"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g922",
    transform: "translate(748.860904, 56.038454)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path924",
    points: "540.121971 238.687158 0.709909744 0.442924623 1.71387222 0.332193468 540.050611 238.100283"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g926",
    transform: "translate(814.394801, 48.768093)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path928",
    points: "469.992239 207.928504 0.285440313 0.472452932 1.00027144 0.39248043 469.941795 207.512647"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g930",
    transform: "translate(879.877146, 34.930266)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path932",
    points: "399.862507 183.32158 0.62747655 6.99082697 60.7569549 0.303895505 395.617813 148.202579"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g934",
    transform: "translate(878.742890, 41.878646)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path936",
    points: "401.092853 177.169849 0.398632161 0.19316435 1.76185572 0.04183177 400.996886 176.373815"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g938",
    transform: "translate(1006.324006, 20.423254)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path940",
    points: "264.524428 124.264964 0.132877387 7.49034752 65.5097821 0.220231965 259.908169 86.0811702"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g942",
    transform: "translate(1006.010514, 26.733577)",
    fill: "#1B1464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path944",
    points: "0 1.23034618 0.446615662 1.17990198 264.838166 117.954518 264.868925 118.215352"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g946",
    transform: "translate(1137.274179, 6.158990)",
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path948",
    points: "124.264964 61.5173088 1.03964252 7.09171536 61.4225721 0.37648593 120.001814 26.2494357"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g950",
    transform: "translate(62.926055, 41.608339)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path952",
    points: "1147.91298 0 0.148871887 127.641034 55.4147918 584.875813 1203.1789 457.23478"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g954",
    transform: "translate(180.604361, 353.086468)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.467811,99.6580403 C205.467811,45.247211 159.483623,1.13930056 102.758513,1.13930056 C46.0334022,1.13930056 0.0479835009,45.247211 0.0479835009,99.6580403 C0.0479835009,154.06887 46.0334022,198.17678 102.758513,198.17678 C159.483623,198.17678 205.467811,154.06887 205.467811,99.6580403 Z",
    id: "path956"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g958",
    transform: "translate(312.787340, 226.899088)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path960",
    points: "190.703657 0 0.697606282 21.1299652 24.3830005 217.081049 214.389052 195.951084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g962",
    transform: "translate(709.096977, 357.760430)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 51.6745394,
    x2: 442.992292,
    y2: 1.07409221,
    id: "path964"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g966",
    transform: "translate(705.958610, 320.117128)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 51.6745394,
    x2: 442.992292,
    y2: 1.07409221,
    id: "path968"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g970",
    transform: "translate(700.042367, 284.512755)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 51.6745394,
    x2: 442.993523,
    y2: 1.07409221,
    id: "path972"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g974",
    transform: "translate(694.377238, 247.243108)",
    stroke: "#E5CDBD",
    strokeWidth: 7.9999998
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 51.6745394,
    x2: 442.992292,
    y2: 1.07409221,
    id: "path976"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g978",
    transform: "translate(1005.805046, 93.407759)",
    fill: "#E5CDBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.652541,4.9213847 C115.237914,6.36827181 113.439148,7.5272579 111.869226,6.98221455 C107.822617,5.57838956 103.291253,5.68050829 99.4168924,7.57647175 C98.5568804,7.99725014 97.7042505,8.47462446 96.9414359,9.04427474 C96.2696669,9.54379529 95.736927,10.1552773 94.8806061,10.3804307 C93.917245,10.6363427 93.0756882,10.3189134 92.1701534,10.0630014 C91.329827,9.82431422 90.4833488,9.62007675 89.6331796,9.43183378 C91.9007076,11.7436542 88.6956558,15.6118626 85.7698926,13.9176759 C80.8460472,11.0632728 75.4731255,9.03935335 69.87382,7.92219903 C71.6110688,10.1725022 73.3483176,12.421575 75.0843361,14.6718781 C76.6923985,16.7523935 74.0286991,19.7630506 71.6110688,19.0051574 C67.7477818,17.7957271 63.7626906,16.896344 59.716082,16.4989422 C56.7927795,16.2122716 52.5259389,15.5134349 50.3839063,18.0011949 C45.95466,23.1465026 51.4912178,30.1385599 54.6864268,34.2995907 C56.4999571,36.6618554 52.9331835,39.980099 50.4774126,38.3363565 L24.7914754,21.1459597 C22.7614043,19.7864272 20.7411758,18.4121305 18.6975708,17.0722835 C17.0366035,15.9821968 15.2870512,14.8305928 13.3603291,14.2178804 C10.8147429,13.4058519 7.00805182,13.5842521 6.26369238,16.4214304 C5.29664029,20.1013958 -0.638549665,18.5413169 0.332193468,14.852739 C1.48010645,10.4813191 6.00778038,7.93819353 10.509617,7.82992306 C15.7742683,7.70442775 20.2724139,10.9451596 24.3719274,13.6900619 C30.6430019,17.8880031 36.9140763,22.0847139 43.1863811,26.282655 C43.1174817,26.0058271 43.0350485,25.7339206 42.9821437,25.4521713 C42.2353235,21.4990691 43.0301272,17.2457623 45.7750295,14.1219134 C48.9074908,10.5576005 53.7636672,10.1380525 58.3061053,10.477628 C60.5145767,10.6424944 62.7058232,10.9340865 64.8798449,11.3118027 C63.3985081,9.3949234 61.9184017,7.47681371 60.4370649,5.55993437 C59.0676896,3.78577518 60.9033661,0.983046595 63.0921519,1.11961502 C69.3496926,1.51209545 75.4620524,2.87901005 81.2176118,5.14899875 C81.4759845,3.78454484 82.4762559,2.52220966 84.1519874,2.6698512 C87.2918308,2.94790944 90.377539,3.47695829 93.4041906,4.28898677 C99.1228397,0.249760274 106.727609,-1.05809771 113.504356,1.29309383 C115.065665,1.83444615 116.117611,3.29978844 115.652541,4.9213847",
    id: "path980"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g982",
    transform: "translate(1075.494929, 76.991496)",
    fill: "#E5CDBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6690397,6.15173088 C46.334837,7.86683345 25.0006343,9.58070567 3.6664316,11.2945779 C2.00915531,11.4274553 0.590566164,9.84276941 0.590566164,8.34420777 C0.590566164,6.63771762 2.00423392,5.52671502 3.6664316,5.39383764 C25.0006343,3.67996541 46.334837,1.96609319 67.6690397,0.25099062 C69.326316,0.118113233 70.7449051,1.70279911 70.7449051,3.2025911 C70.7449051,4.9078509 69.3312374,6.01885349 67.6690397,6.15173088",
    id: "path984"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g986",
    transform: "translate(314.894677, 270.972918)",
    fill: "#D3B39C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.023618,180.860888 C155.168799,180.86827 155.31275,180.863349 155.462852,180.863349 L155.090057,187.48015 C154.939955,187.461695 154.797234,187.44447 154.650823,187.437088 C151.020072,187.247615 147.919599,189.916236 147.721514,193.396885 C147.720283,193.422722 147.721514,193.446099 147.720283,193.469475 L141.574704,193.149585 C141.397534,189.972832 138.747369,187.366958 135.360226,187.191019 C131.971852,187.013849 129.043628,189.329361 128.509658,192.470434 L128.471517,192.467974 L125.898863,192.333866 L122.325938,192.148084 C122.149999,188.97133 119.503524,186.365457 116.11269,186.188287 C112.725547,186.012347 109.798553,188.327859 109.263353,191.467702 L103.042723,191.144121 C102.864322,187.966137 100.215387,185.360264 96.8294744,185.185555 C93.4398707,185.008385 90.5128771,187.323896 89.9801372,190.46497 L83.7570463,190.140159 C83.5811068,186.963405 80.9346321,184.357532 77.5425677,184.180362 C74.1541944,184.004422 71.2272008,186.319934 70.6944609,189.459777 L64.4738307,189.137427 C64.2954305,185.959442 61.6452648,183.352339 58.2605825,183.17763 C54.8697484,183.00046 51.9439852,185.315971 51.410015,188.457045 L45.1881544,188.132234 C45.0097542,184.95548 42.3632795,182.349607 38.9749062,182.172437 C35.5865328,181.996497 32.6583089,184.313239 32.121878,187.451852 L25.902478,187.129502 C25.7265385,183.951517 23.0776032,181.345644 19.6892299,181.169705 C16.2996261,180.992535 13.3726326,183.308046 12.8398927,186.44912 L6.64386935,186.125539 C6.58973412,185.30982 6.37442354,184.534702 6.02254453,183.828483 C5.03334621,181.771344 2.92576321,180.296159 0.403553546,180.165742 L0.775118091,173.592003 C4.40463931,173.780246 7.51003306,171.110394 7.70688845,167.629745 C7.90374383,164.149096 5.11824009,161.170428 1.48871887,160.982185 L1.82091234,155.093748 C5.45166391,155.281991 8.55582731,152.610909 8.7526827,149.13026 C8.94953808,145.649611 6.16526469,142.672173 2.53574347,142.48393 L2.86793694,136.594263 C6.49745816,136.784966 9.6028519,134.116346 9.79970729,130.633236 C9.99656268,127.151356 7.21105894,124.175149 3.58153772,123.985675 L3.91496153,118.096008 C7.54448275,118.285481 10.6486462,115.616861 10.8455015,112.136211 C11.0435873,108.654331 8.25808353,105.679354 4.62856231,105.489881 L4.96075578,99.5989836 C8.590277,99.7872266 11.6956707,97.1198361 11.8925261,93.6367261 C12.0893815,90.1548464 9.30387778,87.1798693 5.67435656,86.990396 L6.00778038,81.1007289 C9.6373016,81.2902022 12.741465,78.6215813 12.9395507,75.1397017 C13.1364061,71.6553613 10.3509024,68.6816146 6.72138116,68.4933716 L7.05357463,62.6049348 C10.6843262,62.7931778 13.7884896,60.1233266 13.985345,56.6426772 C14.1822004,53.1571065 11.397927,50.1821295 7.76717541,49.9938865 L8.10059922,44.1066801 C11.7301204,44.294923 14.8355142,41.6263022 15.0323696,38.1419618 C15.229225,34.6625428 12.4437212,31.6863354 8.8142,31.4968621 L9.14885416,25.607195 C12.777145,25.7978986 15.8813084,23.1292778 16.0793942,19.643707 C16.2762496,16.1630577 13.4907458,13.1880807 9.8612246,12.9986073 L10.1946484,7.10770986 C13.8241696,7.29718317 16.9295634,4.62979266 17.1251884,1.14914333 C17.1411829,0.889540285 17.1313402,0.639780012 17.1141153,0.387559045 L23.3581222,0.713600782 C23.3125993,0.959670017 23.2781496,1.20819994 23.2633855,1.46780299 C23.0665301,4.94845232 25.8532642,7.92342937 29.4803247,8.11290268 C33.1098459,8.30114565 36.212779,5.63375514 36.4096344,2.15187546 C36.4231682,1.89350276 36.4182468,1.64251214 36.3997916,1.39275187 L42.6425681,1.71756326 C42.5982757,1.96486284 42.5625956,2.21339277 42.5478315,2.47176547 C42.3509761,5.95364515 45.1364798,8.92739185 48.766001,9.11563482 C52.3955222,9.30510813 55.4947643,6.63771762 55.69285,3.15583794 C55.7063838,2.8962349 55.7002321,2.64647462 55.6854679,2.395484 L61.9282444,2.72152574 C61.8827216,2.96759498 61.8507326,3.21735525 61.8359685,3.47572795 C61.6391131,6.95760763 64.4209258,9.93135433 68.0516773,10.1208276 C71.6811986,10.3090706 74.7804406,7.6416801 74.977296,4.15980042 C74.9920601,3.90142772 74.9859084,3.6504371 74.9711442,3.40067683 L81.2139207,3.72425787 C81.1683979,3.9727878 81.1327179,4.22131773 81.1191841,4.47969043 C80.9210983,7.9615701 83.7053717,10.9353168 87.3336626,11.1235598 C90.9644142,11.3130331 94.0661169,8.64441223 94.2629723,5.1637629 C94.2789668,4.90415986 94.2703543,4.65439958 94.2543598,4.40340896 L100.499597,4.7294507 C100.452844,4.97675028 100.418394,5.22528021 100.40363,5.48365291 C100.206775,8.96553258 102.988587,11.9380489 106.620569,12.1275223 C110.25009,12.3169956 113.350563,9.64960506 113.547418,6.16772538 C113.562182,5.90935268 113.558491,5.65836206 113.540036,5.40860179 L119.782813,5.73218283 C119.736059,5.97948242 119.70407,6.22924269 119.689306,6.48638504 C119.492451,9.96949506 122.274264,12.9432418 125.903785,13.1314847 C129.535767,13.320958 132.633778,10.6523372 132.830634,7.17168786 C132.845398,6.91208482 132.841707,6.66232454 132.823252,6.41133392 L136.40725,6.59834654 L138.979904,6.73245427 L139.030348,6.73491497 C139.009432,6.84564612 138.994668,6.95760763 138.976213,7.07202982 C138.970061,10.4025769 141.684205,13.1942324 145.194383,13.3763236 C145.339563,13.3837057 145.487205,13.381245 145.636077,13.381245 L145.593015,14.1366776 C149.030602,14.0973065 151.891157,11.5111188 152.0794,8.17441999 C152.094164,7.91481695 152.088012,7.66382633 152.070787,7.41283571 L158.22744,7.73395606 C158.029354,11.2158357 160.811167,14.1895824 164.443148,14.3790558 C164.588329,14.3852075 164.73228,14.3815165 164.883612,14.3827468 L164.547728,20.311785 C164.397626,20.2982512 164.254906,20.2773353 164.109725,20.2711836 C160.477743,20.0817103 157.37727,22.7491008 157.180415,26.2297501 C156.98356,29.7128601 159.765372,32.6878372 163.396124,32.8773105 C163.542535,32.8846926 163.685255,32.8797712 163.836588,32.8810016 L163.500703,38.8112701 C163.351831,38.796506 163.207881,38.7755901 163.0627,38.768208 C159.430718,38.5787347 156.330246,41.2473555 156.13339,44.7280049 C155.936535,48.2135756 158.717117,51.1873223 162.349099,51.3767956 C162.49428,51.385408 162.638231,51.378026 162.789563,51.378026 L162.453679,57.3107552 C162.304807,57.2923 162.162087,57.2738448 162.016906,57.2664628 C158.383694,57.0769894 155.284452,59.7468407 155.087596,63.22749 C154.890741,66.7118304 157.670093,69.6855771 161.303305,69.8750504 C161.448486,69.8824324 161.592436,69.8762807 161.743769,69.8762807 L161.406654,75.8077796 C161.257782,75.7917851 161.115062,75.7696389 160.969881,75.7622568 C157.337899,75.5740139 154.237427,78.2438651 154.040572,81.7257447 C153.843716,85.2076244 156.624299,88.1838318 160.25628,88.3720748 C160.401461,88.3794569 160.545412,88.3745355 160.696744,88.3757658 L160.36086,94.304804 C160.211988,94.2900399 160.069268,94.2678937 159.922857,94.2592812 C156.290875,94.0710383 153.191633,96.7408895 152.994777,100.22523 C152.796692,103.704649 155.577274,106.680856 159.209256,106.87033 C159.355667,106.877712 159.499618,106.874021 159.65095,106.87156 L159.313835,112.804289 C159.164963,112.787064 159.022243,112.767379 158.877062,112.759997 C155.24508,112.570523 152.144608,115.240375 151.947753,118.721024 C151.750897,122.202904 154.53148,125.179111 158.163462,125.368584 C158.308642,125.375966 158.452593,125.371045 158.603926,125.368584 L158.268041,131.301314 C158.119169,131.282858 157.975219,131.264403 157.830038,131.258251 C154.198056,131.067548 151.098814,133.738629 150.900728,137.219279 C150.703873,140.701158 153.484455,143.676135 157.116437,143.865609 C157.261618,143.872991 157.406799,143.87053 157.556901,143.868069 L157.221016,149.799568 C157.072145,149.783574 156.929424,149.763888 156.784244,149.755276 C153.152262,149.565803 150.051789,152.234423 149.854934,155.717533 C149.658078,159.198183 152.437431,162.17439 156.070643,162.362633 C156.215824,162.371246 156.359774,162.366324 156.509876,162.365094 L156.175222,168.296593 C156.02389,168.280598 155.8824,168.260913 155.737219,168.253531 C152.105237,168.064057 149.003534,170.733908 148.807909,174.215788 C148.611054,177.697668 151.391636,180.671415 155.023618,180.860888",
    id: "path988"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g990",
    transform: "translate(248.361124, 328.134802)",
    fill: "#A08470",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.096734,15.9945003 C158.528874,15.6549247 151.274753,17.3035886 144.980302,21.4781532 C138.512372,25.76714 135.094471,32.3876327 130.312115,38.1530349 C119.956291,50.6348969 103.84983,53.0611395 88.1260055,52.597299 C80.7673051,52.3795277 72.0429203,51.3263514 65.4864056,55.2892965 C59.588126,58.8548397 56.0594932,65.3141571 50.8932696,69.713875 C38.320362,80.4252688 21.9444544,79.0952646 6.46300846,76.8154332 C2.16048788,76.1805745 -0.130416695,71.0463399 0.877236823,67.378678 C2.08174573,62.9912635 6.4666995,61.3942742 10.7150848,62.0205204 C18.0577908,63.1019947 26.2691212,64.3372622 33.4961746,62.0783467 C40.200331,59.9830671 44.0599269,54.2041311 48.5605332,49.398399 C59.9449264,37.2438091 74.1763406,36.9546777 90.1080932,37.3151692 C97.2760901,37.4763445 104.906697,37.232736 111.368475,33.8960371 C118.011114,30.465832 121.190329,23.6497142 125.687244,18.1734434 C135.338079,6.42240704 150.548849,-0.0442924623 166.096734,0.652083473 C176.345517,1.11223294 176.403344,16.4571104 166.096734,15.9945003",
    id: "path992"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g994",
    transform: "translate(242.751238, 290.814711)",
    fill: "#A08470",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.48981,15.9945003 C127.962154,14.6952547 119.91446,28.358249 111.261435,36.0799016 C100.869931,45.3530207 89.3575821,47.8358593 75.5014234,47.9847312 C69.3521532,48.0524002 62.65907,47.6955999 57.0056294,50.4331201 C51.9329121,52.8901214 48.3341495,57.6626342 44.4462556,61.4914715 C34.7474367,71.0438792 21.7722059,76.3503623 7.77332714,74.9637622 C-2.36472535,73.9585693 -2.47176547,58.6063097 7.77332714,59.6213453 C14.4811745,60.2857323 21.015543,59.3986527 26.7895576,55.8589467 C32.0136075,52.6563556 35.6824998,47.6943695 40.1166674,43.6293057 C50.2559502,34.3352707 61.9971438,32.7887256 75.5014234,32.6435447 C81.81556,32.5758757 88.3105575,32.6201682 93.977532,29.5799828 C99.2741722,26.7378831 103.320781,22.0342697 107.37108,17.8006485 C116.257871,8.50784381 127.417111,-0.698836628 141.48981,0.653313819 C151.635245,1.62774799 151.741055,16.9800076 141.48981,15.9945003",
    id: "path996"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g998",
    transform: "translate(811.216817, 1177.885199)",
    stroke: "#CEB9AB",
    strokeWidth: 5.3333332
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 345.588246,
    y2: 13.3517167,
    id: "path1000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1002",
    transform: "translate(717.100133, 1097.573861)",
    stroke: "#CEB9AB",
    strokeWidth: 5.3333332
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 429.390815,
    x2: 43.0239754,
    y2: 1.00888386,
    id: "path1004"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostcard);
export default __webpack_public_path__ + "static/media/Postcard.aca8b1a4a8e9d0dfcd843540de492cdd.svg";
export { ForwardRef as ReactComponent };